import React from 'react';
import { formatNumber } from '../../../common/lib/formatNumber';
import type { BapAd } from '../../../types';

type BapSummaryProps = {
    ad: BapAd;
    className?: string;
};

export function BapSummary(props: BapSummaryProps) {
    const { ad, className = '' } = props;

    const priceOrTradeType =
        ad.price.amount > 0 && ad.main_search_key !== 'SEARCH_ID_BAP_WANTED'
            ? `${formatNumber(ad.price.amount)} ${ad.price.price_unit}`
            : ad.trade_type;

    if (!priceOrTradeType) {
        return null;
    }

    return (
        <div className={`${className} space-x-12 font-bold whitespace-nowrap`}>
            <span>{priceOrTradeType}</span>
        </div>
    );
}
